import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6541fe98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card flex-row preloader" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"item-minpic effect-shine\" data-v-6541fe98></div><div class=\"d-flex flex-column\" style=\"width:100%;\" data-v-6541fe98><a style=\"width:100%;\" class=\"card-header card-link text-wrap\" data-v-6541fe98><div class=\"card-link-text rounded-1\" data-v-6541fe98></div></a><div class=\"card-body py-1\" data-v-6541fe98><div class=\"small my-2\" data-v-6541fe98></div></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}